import { DEFAULT_DPI } from './generateFlowcode.constant'
import { FcGeneratorOptions } from '@dtx-company/flowcode-generator-types/src'

export const getFlowcodeUrl = (
  flowcodeOptions: FcGeneratorOptions,
  targetFileType = 'png',
  dpi: string = DEFAULT_DPI
): string => {
  const encodedOptions = encodeURIComponent(JSON.stringify(flowcodeOptions))
  return `${process.env.FLOWCODE_GENERATOR_ROOT}/v1/flowcode?opts=${encodedOptions}&density=${dpi}&imageType=${targetFileType}`
}
